// import { config } from 'shelljs'
import axios from '../axios'
import config from "@/utils/global.js";
/* 
 * 系统登录模块
 */

// 登录
export const login = data => {
    return axios({
        url: config.zuul+'/xyj-admin/r/login',
        method: 'post',
        data
    })
}

// 登出
export const logout = () => {
    return axios({
        url: config.zuul+'/xyj-admin/r/logout',
        method: 'get'
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/login.js